// extracted by mini-css-extract-plugin
export var disabled = "_ax-5";
export var fileName = "_ax-b";
export var filePreview = "_ax-4";
export var hoverFilter = "_ax-6";
export var imageButton = "_ax-3 _ax-6";
export var imageButtonContainer = "_ax-2";
export var input = "_ax-7";
export var removeButton = "_ax-0";
export var removeButtonFile = "_ax-1";
export var spinner = "_ax-9";
export var spinnerContainer = "_ax-8";
export var videoContainer = "_ax-a _ax-6";